import React, { Component } from "react";
import {
  ButtonContinueContainer,
  ButtonContinueContainerContent,
} from "./styles";

class ButtonContinue extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    if (this.props.width != undefined && this.props.width != null) {
      var css = { width: this.props.width };
    } else {
      var css = {};
    }

    return (
      <ButtonContinueContainer>
        {this.props.children != undefined ? this.props.children : <></>}
        <ButtonContinueContainerContent style={css}>
          <button onClick={this.props.onClick} style={css}>
            {this.props.text != undefined ? this.props.text : "CONTINUAR"}
          </button>
        </ButtonContinueContainerContent>
      </ButtonContinueContainer>
    );
  }
}

// function ButtonContinue() {

//   return   ;
// }

export default ButtonContinue;
